<template>
    <div>
        <div class="top">
            <div class="jarallax">
                <div class="nav">
                    <div class="logo">
                        <h1>ground<br>nutmeg</h1>
                    </div>
                    <div class="login">
                        <div v-if="authenticated">
                            <img v-bind:class="[ author ? 'active' : 'inactive']" v-on:click="setAuthor" src="../assets/edit-white-18dp.svg">
                            <img v-on:click="post" src="../assets/add_circle_outline-white-18dp.svg">
                            <img v-on:click="logout" src="../assets/exit_to_app-white-18dp.svg">
                        </div>
                        <div v-else>
                            <img v-on:click="login" src="../assets/login-white-18dp.svg">
                        </div>
                    </div>
                </div>
                
                <div class="search text-center">
                    <form v-on:submit.prevent="scroll">
                    <div class="form-group">
                        <div class="input-group mb-3">
                        <input v-model="filter" autocapitalize="none" autocomplete="off" type="text" ref='search' class="form-control" id="search" placeholder="search recipes">
                        </div>
                    </div>
                    </form>
                </div>
                <div class="down">
                    <div class='recipe-count'>
                        {{ filteredRecipes.length }} recipes
                    </div>
                    <img v-on:click="scroll" src="../assets/keyboard_arrow_down-white-18dp.svg">
                </div>
            </div>
        </div>
        <div ref="recipes"></div>
        <transition-group class='wrapper' name="list" appear>
            <div v-for="recipe in filteredRecipes" v-bind:key="recipe.id">
                <Tile :recipe=recipe></Tile>
            </div>
        </transition-group>
    </div>
</template>

<script>
import Tile from '@/components/Tile.vue'
import { jarallax } from 'jarallax'
import smooth from 'smoothscroll-for-websites'
import { mapGetters } from 'vuex'
export default {
    name: 'Home',
    components: {
        Tile
    },
    created: function () {
        if (!this.recipes.length) {
            this.$store.dispatch('GET_RECIPES', this)
        }
    },
    watch: {
        author: function () {
            this.$store.dispatch('GET_RECIPES', this)
        }
    },
    mounted() {
        jarallax(document.querySelectorAll('.jarallax'))
        smooth({ stepSize: 20 })
        document.title = 'Ground Nutmeg - Delicious Recipes'
        document.getElementsByTagName('meta')["description"].content = 'A curated collection of classic recipes'
        document.head.querySelector("script[type='application/ld+json']").textContent = JSON.stringify()
        // 100% height on mobile (without address bar)
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    computed: {
        ...mapGetters([
            'recipes',
            'author',
            'authenticated'
        ]),
        filteredRecipes() {
            let filtered = []
            for (let i = 0; i < this.recipes.length; ++i) {
                if (
                    this.recipes[i]['title'].toLowerCase().includes(this.filter.toLowerCase()) || 
                    this.recipes[i]['tags'].includes(this.filter.toLowerCase())
                ) {
                    filtered.push(this.recipes[i])
                }
            }
            return filtered
        }
    },
    data () {
        return {
            filter: ''
        }
    },
    methods: {
        scroll: function () {
            this.$nextTick(() => {
                this.$refs.search.blur()
                setTimeout(() => {
                    this.$refs.recipes.scrollIntoView({behavior: "smooth", block: "start"})
                }, 100)
            })
        },
        setAuthor: function () {
            if (this.author) {
                this.$store.dispatch('SET_READER')
            } else {
                this.$store.dispatch('SET_AUTHOR')
            }
        },
        post: function () {
            this.$router.push('post')
        },
        login: function () {
            window.location.replace("https://" + window.authEndpoint + "/login?response_type=code&client_id=" + window.cognitoAppClientId + "&redirect_uri=https://" + window.redirectUri)
        },
        logout: function () {
            this.$store.dispatch('LOGOUT')
        }
    }
}
</script>

<style scoped>
@media (max-width: 1050px) {
    .logo h1 {
        font-size: 1.5em;
    }
    .login h1 {
        font-size: 1em;
    }
    .login img {
        height: 20px;
        margin-left: 10px;
    }
}
@media (min-width: 1050px) {
    .logo h1 {
        font-size: 2.5em;
    }
    .login h1 {
        font-size: 1.5em;
    }
    .login img {
        height: 30px;
        margin-left: 20px;
    }
}
.wrapper {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100vw;
    flex-wrap: wrap;
    padding: 0px;
    justify-content: center;
}
.container-fluid {
    padding-left: 0px;
    padding-right: 0px;
}
.top {
    background-color: #000000;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
}
.jarallax {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    justify-content: center;
    display: flex;
}
@media (max-width: 450px) {
    .jarallax {
        background: linear-gradient(
            to top,
            rgba(0,0,0, 0.7),
            rgba(0,0,0, 0) 40%,
            rgba(0,0,0, 0) 60%,
            rgba(0,0,0, 0.7)
        ), url('../assets/bg-v2-medium.jpg');
    }
}
@media (min-width: 450px) {
    .jarallax {
        background: linear-gradient(
            to top,
            rgba(0,0,0, 0.7),
            rgba(0,0,0, 0) 40%,
            rgba(0,0,0, 0) 60%,
            rgba(0,0,0, 0.7)
        ), url('../assets/bg-v2-big.jpg');
    }
}
.logo {
    width: 50%;
    text-align: left;
    align-items: top;
    font-family: 'Comfortaa', Arial;
    padding-top: 5vh;
    padding-left: 15px;
}
.logo h1 {
    color: #f5f5f5;
    transition: all 0.3s;
}
.login {
    width: 50%;
    text-align: right;
    padding-top: 5vh;
    padding-right: 15px;
}
.login img {
    cursor: pointer;
}
.down {
    bottom: 5vh;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.down img {
    width: 15vw;
    max-width: 50px;
    cursor: pointer;
}
.active {
    transition: opacity 100ms ease-in-out;
    opacity: 1;
}
.inactive {
    transition: opacity 100ms ease-in-out;
    opacity: 0.5;
}
.search {
    top: 40vh;
    position: absolute;
}
.input-group {
  width: 300px;
}
.form-control {
    background-color: rgb(0,0,0,0.3);
    backdrop-filter: blur(16px);
    color: #ffffff;
    font-family: 'Comfortaa', Arial;
    font-size: 1.8em;
    text-align: center;
    height: 60px;
    box-shadow: none;
}
.form-control::placeholder {
  color: rgb(255,255,255,0.5);
  font-family: 'Comfortaa', Arial;
  opacity: 1;
}
.form-control:focus {
    border-color: #ffffff;
}
.recipe-count {
    color: #ffffff;
    font-family: 'Comfortaa', Arial;
    font-size: 1.4em;
}
@media (max-width: 700px) {
    .nav {
        width: 350px;
    }
}
@media (min-width: 700px) and (max-width: 1050px){
    .nav {
        width: 700px;
    }
}
@media (min-width: 1050px) and (max-width: 1400px) {
    .nav {
        width: 1050px;
    }
}
@media (min-width: 1400px) and (max-width: 1750px) {
    .nav {
        width: 1400px;
    }
}
@media (min-width: 1750px) and (max-width: 2100px) {
    .nav {
        width: 1750px;
    }
}
@media (min-width: 2100px) and (max-width: 2450px) {
    .nav {
        width: 2100px;
    }
}
@media (min-width: 2450px) and (max-width: 2800px) {
    .nav {
        width: 2450px;
    }
}
@media (min-width: 2800px) and (max-width: 3150px) {
    .nav {
        width: 2800px;
    }
}
@media (min-width: 3150px) and (max-width: 3500px) {
    .nav {
        width: 3150px;
    }
}
@media (min-width: 3500px) and (max-width: 3850px) {
    .nav {
        width: 3500px;
    }
}
@media (min-width: 3850px) and (max-width: 4200px) {
    .nav {
        width: 3850px;
    }
}
@media (min-width: 4200px) and (max-width: 4560px) {
    .nav {
        width: 4200px;
    }
}
.list-leave-active {
    position: absolute;
}
.list-enter-active {
    transition: transform 200ms, opacity 200ms;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.list-move {
    transition: transform 500ms;
}
</style>